import { z } from "zod";

import { sectionSchema } from "./home/sectionSchema";

export const pagesSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional().nullable(),
  sections: sectionSchema.array(),
});

export type Pages = z.infer<typeof pagesSchema>;
